import { customElement, property } from 'lit/decorators.js';
import { html, LitElement } from 'lit';
import { styles } from '../view/styles';
import { FontSizes } from '../../../../../types/common/types';
import { CustomRulesEvents } from '../../../../customRulesGrid/types';

/**
 * @summary Type here the description of this component
 * @tag endpoint-tag
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('endpoint-tag')
export class EndpointTagWebComponent extends LitElement {
  @property({ type: Object, attribute: false, reflect: false })
  tag;

  @property({ type: Boolean })
  isPartnerCompany = false;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    const deleteButton = html`<gz-icon-button
      icon="ds-icon-delete_large"
      size="24"
      fontsize="20"
      buttontype="round"
      buttonfill="quiet"
      buttoncolor="secondary"
      @click="${this.handleDelete}"
    ></gz-icon-button>`;

    return this.isPartnerCompany
      ? html`<div class="d-flex flew-row align-items-center endpoint-selected-tag">
          <gz-tooltip isEllipsis tooltipText="${this.tag.parent + ' / ' + this.tag.label}">
            <gz-text fontSize="${FontSizes.PARAGRAPH_12}" class="d-inline"
              >${this.tag.parent + ' / ' + this.tag.label}</gz-text
            ></gz-tooltip
          >${deleteButton}
        </div>`
      : html`<div class="d-flex flew-row align-items-center endpoint-selected-tag">
          <gz-tooltip isEllipsis tooltipText="${this.tag.label}"
            ><gz-text fontSize="${FontSizes.PARAGRAPH_12}" class="d-inline">${this.tag.label}</gz-text></gz-tooltip
          >${deleteButton}
        </div>`;
  }

  private handleDelete() {
    this.dispatchEvent(new CustomEvent(CustomRulesEvents.DELETE));
    this.remove();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'endpoint-tag': EndpointTagWebComponent;
  }
}
